import { render, staticRenderFns } from "./EstilosEditor.vue?vue&type=template&id=7320b39d"
import script from "./EstilosEditor.vue?vue&type=script&lang=js"
export * from "./EstilosEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports